import React from 'react'
import Edit from '../../crud/edit'

const editFields = [{
  name: 'Adjusted Invoice Date',
  prop: 'adjusted_invoice_date',
  type: 'datetime'
}, {
  name: 'Last Sent At',
  prop: 'last_sent_at',
  type: 'datetime',
  disabled: true
}, {
  name: 'Created At',
  prop: 'created_at',
  type: 'datetime',
  disabled: true
}, {
  name: 'Updated At',
  prop: 'updated_at',
  type: 'datetime',
  disabled: true
}, {
  name: 'Billing Contact Name',
  prop: 'payer_billing_name',
  type: 'text'
}, {
  name: 'Billing Contact Email',
  prop: 'payer_billing_email',
  type: 'text'
}, {
  name: 'Institution',
  prop: 'payer_institution',
  type: 'text'
}, {
  name: 'Address Line 1',
  prop: 'payer_address_line_1',
  type: 'text'
}, {
  name: 'Address Line 2',
  prop: 'payer_address_line_2',
  type: 'text'
}, {
  name: 'City',
  prop: 'payer_city',
  type: 'text'
}, {
  name: 'Country',
  prop: 'payer_country',
  type: 'text'
}, {
  name: 'State',
  prop: 'payer_state',
  type: 'text'
}, {
  name: 'Zip/Postal Code',
  prop: 'payer_postal_code',
  type: 'text'
}]

const EditInvoice = props => (
  <Edit
// @ts-ignore
    title='Edit Invoice'
    fields={editFields}
    apiPath={`admin/orders/${props.params.orderId}/invoice`}
    disableDelete
    successRedirectPath={`/ecommerce/orders/${props.params.orderId}/manage`}
  />
)

// @ts-ignore
EditInvoice.propTypes = {
  params: React.PropTypes.shape({
    orderId: React.PropTypes.string.isRequired
  }).isRequired
}

export default EditInvoice
